
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/auth";

export const DashboardRedirectButton = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleManualRedirect = () => {
    if (user) {
      const needsOrgSetup = localStorage.getItem("needsOrgSetup");
      if (needsOrgSetup === "true") {
        navigate("/organization-setup");
      } else {
        navigate("/dashboard");
      }
    }
  };

  if (!user) return null;

  return (
    <div className="text-center pt-4">
      <Button
        onClick={handleManualRedirect}
        className="w-full bg-green-600 hover:bg-green-700"
      >
        Accéder au tableau de bord
      </Button>
      <p className="text-xs text-gray-500 mt-2">
        Vous êtes connecté. Cliquez sur le bouton pour accéder à votre tableau de bord.
      </p>
    </div>
  );
};
